<template>
  <div>
    <!-- Auth loading skeleton -->
    <v-skeleton-loader v-if="isAuthLoading" type="button" width="88" height="28" />

    <!-- Signed in with Google — show email chip with sign-out menu -->
    <v-menu v-else-if="isGoogleUser" offset-y>
      <template #activator="{ on, attrs }">
        <v-chip
          small
          v-bind="attrs"
          v-on="on"
          color="#2e2e38"
          style="cursor:pointer;max-width:180px"
        >
          <v-avatar left size="20" color="primary">
            <span style="font-size:10px;color:white;line-height:1">
              {{ emailInitial }}
            </span>
          </v-avatar>
          <span class="text-truncate" style="font-size:12px;color:#f0eff6">
            {{ currentUserEmail }}
          </span>
        </v-chip>
      </template>
      <v-list dense style="background:#1f1f24;border:1px solid #2e2e38;min-width:140px">
        <v-list-item @click="handleSignOut">
          <v-list-item-icon class="mr-2">
            <v-icon small color="#7b7a8e">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title style="font-size:13px;color:#f0eff6">Sign out</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Not signed in or anonymous — show "Sign in" button -->
    <v-btn
      v-else
      text small
      class="nav-btn"
      :loading="signingIn"
      @click="handleSignIn"
    >
      <v-icon left small>mdi-google</v-icon>
      Sign in
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import supabase from '@/api/supabase/index'

export default {
  name: 'LoginButton',

  data () {
    return {
      signingIn: false,
    }
  },

  computed: {
    ...mapState(['isAuthLoading']),
    ...mapGetters(['isGoogleUser', 'isAnonymousUser', 'currentUserEmail']),

    emailInitial () {
      return this.currentUserEmail ? this.currentUserEmail[0].toUpperCase() : '?'
    },
  },

  methods: {
    async handleSignIn () {
      this.signingIn = true
      try {
        if (this.isAnonymousUser) {
          await supabase.linkGoogleIdentity()
        } else {
          await supabase.signInWithGoogle()
        }
        // OAuth redirect happens; onAuthStateChange in App.vue handles the return
      } finally {
        this.signingIn = false
      }
    },

    async handleSignOut () {
      await supabase.signOut()
      this.$store.commit('clearUser')
    },
  },
}
</script>

<style scoped>
.nav-btn {
  font-size: 13px !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  color: #7b7a8e !important;
  text-transform: none !important;
  border-radius: 8px !important;
}

.nav-btn:hover {
  color: #f0eff6 !important;
  background: #2e2e38 !important;
}
</style>
